var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2920_38566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0592 0.440613C12.4732 -0.145325 11.5217 -0.145325 10.9357 0.440613L7.93574 3.44061C7.34981 4.02655 7.34981 4.97811 7.93574 5.56405C8.52168 6.14999 9.47324 6.14999 10.0592 5.56405L10.4998 5.12343V10.5H5.12324L5.56387 10.0594C6.14981 9.47343 6.14981 8.52186 5.56387 7.93593C4.97793 7.34999 4.02637 7.34999 3.44043 7.93593L0.44043 10.9359C-0.145508 11.5219 -0.145508 12.4734 0.44043 13.0594L3.44043 16.0594C4.02637 16.6453 4.97793 16.6453 5.56387 16.0594C6.14981 15.4734 6.14981 14.5219 5.56387 13.9359L5.12324 13.4953H10.4998V18.8766L10.0592 18.4359C9.47324 17.85 8.52168 17.85 7.93574 18.4359C7.34981 19.0219 7.34981 19.9734 7.93574 20.5594L10.9357 23.5594C11.5217 24.1453 12.4732 24.1453 13.0592 23.5594L16.0592 20.5594C16.6451 19.9734 16.6451 19.0219 16.0592 18.4359C15.4732 17.85 14.5217 17.85 13.9357 18.4359L13.4951 18.8766V13.5H18.8764L18.4357 13.9406C17.8498 14.5266 17.8498 15.4781 18.4357 16.0641C19.0217 16.65 19.9732 16.65 20.5592 16.0641L23.5592 13.0641C24.1451 12.4781 24.1451 11.5266 23.5592 10.9406L20.5592 7.94061C19.9732 7.35468 19.0217 7.35468 18.4357 7.94061C17.8498 8.52655 17.8498 9.47811 18.4357 10.0641L18.8764 10.5047H13.4998V5.12343L13.9404 5.56405C14.5264 6.14999 15.4779 6.14999 16.0639 5.56405C16.6498 4.97811 16.6498 4.02655 16.0639 3.44061L13.0639 0.440613H13.0592Z",
    fill: "#ECEEEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2920_38566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReorder);
export default __webpack_public_path__ + "static/media/reorder.5724ed4afad885631a3e5af8b53053c0.svg";
export { ForwardRef as ReactComponent };